// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Wait until DOM and all layout-affecting components are ready
    const handleScroll = () => {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } else {
        // Force scroll to absolute top
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
    };

    // Use small delay to allow animations/sliders to mount
    const timeout = setTimeout(handleScroll, 300);
    return () => clearTimeout(timeout);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
